<template>
    <div class="row">
        <div class="col-md-6">
            Promo Code:<br/>
            <input class="promoCode form-control" v-model="rule.settings.promo_code" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            rule: Object
        }
    }
</script>